var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-dialog" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": [_vm.message.reason],
            fullscreen: _vm.message.fullscreen,
            persistent: _vm.message.persistent
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _vm.message.reason === "native-app"
            ? _c("div", [
                _vm.userAgent === "android" || _vm.userAgent === "ios"
                  ? _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", [
                          _vm._v(_vm._s(_vm.$t("appInstaller.addTo.Title")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("appInstaller.addTo.content")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.appDownload()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "appInstaller.nativeApp" +
                                        _vm.userAgent +
                                        ".appDwn"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "app-link" }, [
                            _c(
                              "a",
                              {
                                staticClass: "app-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("appInstaller.addTo.continue"))
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm.message.reason === "native-failed-geolocation"
            ? _c("div", { class: [_vm.message.reason] }, [
                _vm.userAgent === "android" || _vm.userAgent === "ios"
                  ? _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        !_vm.message.action
                          ? _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("nativeApp.failedGeolocation.title")
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.message.action === "deposit"
                          ? _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "nativeApp.failedGeolocation.titleDeposit"
                                  )
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "nativeApp.failedGeolocation.contect." +
                                  _vm.state
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "msg-red" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("nativeApp.failedGeolocation.suggestion")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("Geolocation.ErrorMessage.OK"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm.message.reason === "common"
            ? _c("div", { class: [_vm.message.reason] }, [
                _c("div", { staticClass: "text-wrapper" }, [
                  _vm.message.reasonTitle
                    ? _c("h1", [_vm._v(_vm._s(_vm.message.reasonTitle))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.message.reasonDescription
                    ? _c("p", [_vm._v(_vm._s(_vm.message.reasonDescription))])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _vm.message.onCloseAction
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "primary-btn-blue",
                            attrs: { block: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.closeDialogue(
                                  _vm.message.onCloseAction
                                )
                              }
                            }
                          },
                          [_vm._v("Close")]
                        )
                      : _c(
                          "v-btn",
                          {
                            staticClass: "primary-btn-blue",
                            attrs: { block: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.closeDialogue()
                              }
                            }
                          },
                          [_vm._v("Close")]
                        )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbd4156a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbd4156a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/MessageDialog.vue
// module id = null
// module chunks = 